module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av730-41769fd09256248654c01bf05ede01b4.jpg";